import { OrderedMap, Record } from 'immutable';
import { Submittal } from 'records/Submittal';
import { SubmittalQuery } from 'records/SubmittalQuery';

export type LinkId = string;

export interface RawSubmittalFilter {
  submittals: OrderedMap<string, Submittal>;
  submittalQuery: SubmittalQuery;
}

export interface SubmittalFilterData {
  submittals: OrderedMap<string, Submittal>;
  submittalQuery: SubmittalQuery;
}

const defaultValues: SubmittalFilterData = {
  submittals: OrderedMap<string, Submittal>(),
  submittalQuery: new SubmittalQuery(),
};

export const SubmittalFilterFactory = Record(defaultValues, 'SubmittalFilter');

export class SubmittalFilter extends SubmittalFilterFactory {
  static deserialize(rawSubmittalFilter: RawSubmittalFilter): SubmittalFilter {
    return new SubmittalFilter({
      ...rawSubmittalFilter,
    });
  }
}
